export enum ChatRoles {
  Client = 'client',
  Provider = 'provider',
  Moderator = 'moderator',
}

// Switches and flags
export const CHAT_PRO_FEATURE_FLAG = 'pro_messaging_beta_enabled_com911_20221026';
export const CHAT_GENERAL_SWITCH = 'general_messaging_beta_enabled_com911_20221026';
export const CHAT_TOUR_SWITCH = 'pro_messaging_tour_enabled_com911_20221026';

// User state actions for state manager
export const CHAT_TOUR_VIEWED = 'chat_tour_viewed';
export const CHAT_WELCOME_MESSAGE_SENT = 'chat_welcome_message_sent';
